// extracted by mini-css-extract-plugin
export default {"main":"NoAccessScreen_main__1o-Oi"};